<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">
  <div class="pageTitle">
    {{tittle}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>

  </div>
  <div class="subBlockContent">

    <div class="row">
      <div class="col-md-8 ">
        <div class="main-background">
          About Us Dicker Data (ASX: DDR) is an Australian owned and operated, ASX listed hardware distributor with over 40 years'
          experience. Our dedicated sales and presales teams comprises of experienced product specialists who are focused
          on using their in-depth knowledge to help customers tailor solutions to suit their client’s needs. Selling exclusively
          to over 5,000 resellers, Dicker Data prides itself on establishing and developing strong long term relationships
          with its customer base to help facilitate growth. Dicker Data’s customer-centric approach allows for proactive
          reseller engagement and the dynamic ability to shift with changing market conditions. Dicker Data's product portfolio
          comprises of leading technology vendors including HP, Cisco, Toshiba, ASUS, Lenovo, Microsoft and other tier 1
          global brands. Currently positioned as the leading distributor for several of these vendors in Australia, Dicker
          Data has enjoyed continuous growth despite the current economic climate. Dicker Data plans to continue this growth
          through proactive reseller enablement and expanding upon the success experienced with existing competitive strategies.
          Account Management Dicker Data is fully equipped to deal with the extended needs of customers with special requirements.
          Our team is willing to be as flexible as necessary to best help your business grow. We have a number of Specific
          Programs to assist you to build your business such as: Drop ship delivery program Eclipse Program for HP Large
          Business Opportunities EPR Program for Toshiba notebooks for larger corporate accounts requiring volume pricing
          Server and Storage presales team Imaging and configuration Credit Options Dicker Data offers a range of credit
          options including: Direct Transfer BPAY (Biller Code: 89946) Credit Card (VISA, Mastercard, American Express) MoneyTech
          30 Days from Monthly Statement Credit Account Surcharge on Credit Cards 0% - VISA/Mastercard 2% - MoneyTech 2.1%
          - American Express Effective 01 July 2011, payment of Credit Term Accounts using VISA or Mastercard will incur
          a 1% fee
        </div>
      </div>

      <div class="col-md-4 ">
        <div class="side-background">
          Download a copy of the Dicker Data contact sheet ABN 95 000 969 362 Pick-Up/Delivery Address (9AM to 4PM) 230 Captain Cook
          Drive Kurnell, NSW 2231 Phone Contacts General Enquiries: 1800 688 586 Account Enquiries: (02) 9589 8409 Fax Number:
          1800 688 486 Hardware Sales: (02) 9589 8400 Software Sales: (02) 8556 8060 Cisco Presales: (02) 8556 8051 HPE &
          Lenovo EBG Presales: (02) 8556 8052 Microsoft Sales: (02) 8556 8061 Email Contacts Orders: orders@dickerdata.com.au
          Sales Enquiries/Quotes: sales@dickerdata.com.au Returns: ras@dickerdata.com.au Dicker Data Services: services.sales@dickerdata.com.au
          Cisco Presales: cisco.presales@dickerdata.com.au HPE & Lenovo EBG Presales: presales@dickerdata.com.au Microsoft
          Licensing: microsoft.sales@dickerdata.com.au Software Licensing: licensing@dickerdata.com.au Banking Details Westpac
          Banking Corporation BSB: 032-052 Account Number: 286 617 Swift Code: WPACAU2S BPAY Details Biller Code: 89946
        </div>

      </div>

    </div>


  </div>
  <div #entry>


  </div>
</div>
